import { Directive, Input, TemplateRef } from "@angular/core";

@Directive({
    selector: "ng-template[dtmMainPageLibKpoEntity]",
})
export class EntityDirective {
    @Input({ required: true }) public name!: string;
    @Input({ required: true }) public voivodeship!: string;

    constructor(public templateRef: TemplateRef<unknown>) {}
}
